import React from 'react';
import styled from 'styled-components';
import { Breakpoints, getSize } from '../../DesignSystem/design-system';
const PadContainer = styled.div `
  box-sizing: border-box;
  ${(props) => props.padding && `padding: ${props.padding};`}
  ${(props) => props.paddingLeft && `padding-left: ${getSize(props.paddingLeft)};`}
  ${(props) => props.paddingRight && `padding-right: ${getSize(props.paddingRight)};`}
  ${(props) => props.paddingTop && `padding-top: ${getSize(props.paddingTop)};`}
  ${(props) => props.paddingBottom && `padding-bottom: ${getSize(props.paddingBottom)};`}
  ${(props) => props._isVisible && 'background-color: #ccc;'}
  ${(props) => props.fluid && `height: 100%;`}
  ${(props) => props.fluid && `width: 100%;`}

  @media (max-width: ${Breakpoints.Mobile}) {
    ${(props) => props.mobilePadding && `padding: ${props.mobilePadding};`}
  }
`;
/**
 * A container component for adding padding.
 *
 * @param _isVisible - If true, the container will be visible.
 * @param {React.ReactNode} props.children - The child components that ImpPad will wrap.
 * @param {string} [props.padding] - Optional. The overall padding for the container. Written as a string (using CSS shorthand).
 * @param {size} [props.paddingTop] - Optional. The padding-top for the container.
 * @param {size} [props.paddingRight] - Optional. The padding-right for the container.
 * @param {size} [props.paddingBottom] - Optional. The padding-bottom for the container.
 * @param {size} [props.paddingLeft] - Optional. The padding-left for the container.
 * @param {boolean} [props.fluid=false] - If true, the container will take the full width and height of its parent.
 * @param {string} [props.dataTestId='pad-container'] - Optional. The data-testid of the container.
 * @param {boolean} [props._isVisible=false] - If true, the container will have a background color of #ccc.
 * @returns The ImpPad component.
 */
export default function ImpPad({ _isVisible = false, dataTestId = 'pad-container', ...args }) {
    return (React.createElement(PadContainer, { _isVisible: _isVisible, "data-testid": dataTestId, ...args }, args.children));
}
//# sourceMappingURL=ImpPad.js.map